import React from 'react'

export interface SceneContextTypes {
  hitBoxGroupName: string
  hitboxVisible: boolean
  disablePuck: boolean
  disableInteraction: boolean
  focusTargets: string[]
}

const initContextValue: SceneContextTypes = {
  hitBoxGroupName: '',
  hitboxVisible: false,
  disablePuck: false,
  disableInteraction: false,
  focusTargets: [],
}

const SceneContext = React.createContext(initContextValue)

export default SceneContext
